import { IShowPlaceOrderText } from './types';

export const showPlaceOrderText = ({
  reloadAndPlaceOrder = 0,
  confirmation = false,
}: IShowPlaceOrderText) => {
  if (reloadAndPlaceOrder) {
    return confirmation ? 'reloadAndPlaceOrder' : 'reloadAndContinue';
  }

  return confirmation ? 'placeSecureOrder' : 'continue';
};
